<gx-theme-banner>
    {{ stepName }}
    <span *ngIf="totalStepCount">{{ stepNumber }} / {{ totalStepCount }}</span>
    - {{ tournamentName }}
    Registration
</gx-theme-banner>
